import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, Form, FormFeedback, Label, Input } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link } from 'react-router-dom';
import logoSm from "../../assets/images/logo-sm.png";
import { pb } from "../../helpers/pocketbase_helper"; 

const ForgetPasswordPage = () => {
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Por favor ingrese un email válido"),
    }),
    onSubmit: async (values) => {
      setError("");
      setSuccessMsg("");
      try {
        await pb.collection('users').requestPasswordReset(values.email);
        setSuccessMsg("Se ha enviado el email para restaurar la contraseña.");
      } catch (err) {
        setError(err?.message || "Falló al enviar el email de restauración de contraseña.");
      }
    }
  });

  document.title = "Restaurar contraseña | GraphicForce - Printesco";
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20 p-2">Restaurar contraseña</h5>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="24" alt="logo" />
                    </Link>
                  </div>
                </div>
                <CardBody className="p-4">

                  {error && (
                    <Alert color="danger" style={{ marginTop: "13px" }} className="mt-5">
                      {error}
                    </Alert>
                  )}
                  {successMsg && (
                    <Alert color="success" style={{ marginTop: "13px" }} className="mt-5">
                      {successMsg}
                    </Alert>
                  )}

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                    className="mt-4">

                    <div className="mb-3">
                      <Label className="form-label" htmlFor="useremail">Email</Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="Ingrese el email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                      ) : null}
                    </div>

                    <div className="row  mb-0">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Restaurar</button>
                      </div>
                    </div>

                  </Form>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>¿ Recordaste el password ? <Link to="/login" className="fw-medium text-primary"> Ingrese aquí </Link> </p>
                <p>
                  © {new Date().getFullYear()} GraphicForce - Printesco. {" "}
                  <i className="mdi mdi-heart text-danger" /> by Appcomercio
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ForgetPasswordPage;